module.exports = __webpack_public_path__ + "img/banner.958863b1.png";